import React, { lazy, Suspense } from "react";
import Sidebar from "../../Module/sidebar";
import { Route, Routes } from "react-router";

import { useSelector } from "react-redux";
import {
  AiEmpSidebarData,
  AiPanelSidebarData,
} from "../../Module/aiPanelSidebarData";
import Loading from "../../Component/Loading";
import QuestionExtractor from "./AI Command/QuestionExtractor";
import PyqAnalyticsDashboard from "./knowledgeBaseUpload/pyqAnalyticsDashboard";
import CropImageZipUpload from "./knowledgeBaseUpload/cropImageZipUpload";
import PyqQuestionExtraction from "./AI Command/pyqQuestionExtraction";
import PartwiseQuestionData from "./AI Command/partwiseQuestionData";
import PyqExtraction from "./AI Command/pyqExtraction";

// Movements of Meeting (same pages as the other panels)
const MovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/movementsOfMeeting"),
);
const EditMovementsOfMeeting = lazy(() =>
  import("../CategoryPanel/MovementsOfMeeting/editMovementsOfMeeting"),
);
/*********************************************************** */

const CreateExam = React.lazy(() => import("../AdminPanel/createExam"));
const EditDeleteExam = React.lazy(() => import("../AdminPanel/editDeleteExam"));
const CreateSubExam = React.lazy(() => import("../AdminPanel/createSubExam"));
const EditDeleteSubExam = React.lazy(
  () => import("../AdminPanel/editDeleteSubExam"),
);
const CreateParentCourse = React.lazy(
  () => import("../AdminPanel/createParentCourse"),
);
const EditDeleteParentCourse = React.lazy(
  () => import("../AdminPanel/editDeleteParentCourse"),
);
const CreateSubject = React.lazy(() => import("../AdminPanel/createSubject"));
const EditDeleteSubject = React.lazy(
  () => import("../AdminPanel/editDeleteSubject"),
);
const CreatePattern = React.lazy(() => import("../AdminPanel/createPattern"));
const EditDeletePattern = React.lazy(
  () => import("../AdminPanel/editDeletePattern"),
);
const SubjectFileUpload = React.lazy(() => import("./subjectFileUpload"));
const DisplayUploadedExtractedData = React.lazy(
  () => import("./displayUploadedExtractedData"),
);
const PyqFileUpload = React.lazy(() => import("./pyqFileUpload"));
const KnowledgeBaseUpload = React.lazy(
  () => import("../AIPanel/knowledgeBaseUpload/knowledgeBaseUpload"),
);
const SubjectwiseKnowledgeBaseUpload = React.lazy(
  () => import("../AIPanel/knowledgeBaseUpload/subjectwiseKnowledgeBaseUpload"),
);
const PyqKnowledgeBaseUpload = React.lazy(
  () => import("../AIPanel/knowledgeBaseUpload/pyqKnowledgeBaseUpload"),
);
const AICommand = React.lazy(() => import("../AIPanel/AI Command/AICommand"));
const QuestionsReview = React.lazy(
  () => import("../AIPanel/QuestionsReview/AiQuestionsReview"),
);
const StructuredKnowledge = React.lazy(
  () => import("../AIPanel/structuredKnowledge/StructuredKnowledge"),
);
const GeneratedSet = React.lazy(
  () => import("../AIPanel/GeneratedSets/GeneratedSets"),
);
const SubjectWiseKnowledge = React.lazy(
  () => import("../AIPanel/knowledgeBaseUpload/subjectWiseKnowledge"),
);
const CreateTopic = React.lazy(() => import("../DataEntryPanel/createTopic"));
const CreateSubTopic = React.lazy(
  () => import("../DataEntryPanel/createSubTopic"),
);
const EditDeleteSubTopic = React.lazy(
  () => import("../DataEntryPanel/editDeleteSubTopic"),
);
const EditDeleteTopic = React.lazy(
  () => import("../DataEntryPanel/editDeleteTopic"),
);
/*********************************************************** */
const AIDashboard = () => {
  const { loginType } = useSelector((state) => ({
    loginType: state.Auth?.loginType,
  }));

  return (
    <div className="AppBox">
      <Sidebar data={loginType === 2 ? AiEmpSidebarData : AiPanelSidebarData} />
      <div className="dashboard">
        {
          <Suspense
            fallback={
              <div className="border p-1">
                <Loading />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<CreateExam />} />
              <Route path="createExam" element={<CreateExam />} />
              <Route path="editDeleteExam" element={<EditDeleteExam />} />
              <Route path="createSubExam" element={<CreateSubExam />} />
              <Route path="editDeleteSubExam" element={<EditDeleteSubExam />} />
              <Route
                path="createParentCourse"
                element={<CreateParentCourse />}
              />
              <Route
                path="editDeleteParentCourse"
                element={<EditDeleteParentCourse />}
              />
              <Route path="createSubject" element={<CreateSubject />} />
              <Route path="editDeleteSubject" element={<EditDeleteSubject />} />
              <Route path="createPattern" element={<CreatePattern />} />
              <Route path="editDeletePattern" element={<EditDeletePattern />} />
              <Route path="subjectFileUpload" element={<SubjectFileUpload />} />
              <Route
                path="displayUploadedExtractedData"
                element={<DisplayUploadedExtractedData />}
              />
              <Route path="pyqFileUpload" element={<PyqFileUpload />} />
              <Route
                path="knowledgeBaseUpload"
                element={<KnowledgeBaseUpload />}
              />
              <Route
                path="subjectwiseKnowledgeBaseUpload"
                element={<SubjectwiseKnowledgeBaseUpload />}
              />
              <Route
                path="pyqKnowledgeBaseUpload"
                element={<PyqKnowledgeBaseUpload />}
              />
              <Route
                path="pyqQuestionExtraction"
                element={<PyqQuestionExtraction />}
              />
              <Route
                path="partwiseQuestionData"
                element={<PartwiseQuestionData />}
              />
              <Route path="pyqExtraction" element={<PyqExtraction />} />
              <Route path="AIExamSet" element={<AICommand />} />
              <Route path="questionsReview" element={<QuestionsReview />} />
              <Route
                path="structuredKnowledge"
                element={<StructuredKnowledge />}
              />
              <Route path="generatedSets" element={<GeneratedSet />} />
              <Route path="questionExtractor" element={<QuestionExtractor />} />
              <Route
                path="subjectWiseKnowledge"
                element={<SubjectWiseKnowledge />}
              />
              <Route
                path="pyqAnalyticsDashboard"
                element={<PyqAnalyticsDashboard />}
              />
              <Route
                path="CropImageZipUpload"
                element={<CropImageZipUpload />}
              />
              <Route path="createTopic" element={<CreateTopic />} />
              <Route path="editdeleteTopic" element={<EditDeleteTopic />} />

              <Route path="createSubTopic" element={<CreateSubTopic />} />
              <Route
                path="editDeleteSubTopic"
                element={<EditDeleteSubTopic />}
              />
              <Route path="movementsOfMeeting" element={<MovementsOfMeeting />} />
              <Route path="editMovementsOfMeeting" element={<EditMovementsOfMeeting />} />
            </Routes>
          </Suspense>
        }
      </div>
    </div>
  );
};

export default AIDashboard;
